import { useState } from "react";
import { HelpCircle, Plus, Minus } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const FaqSection = () => {
  const sectionRef = useScrollReveal();
  const [activeFaq, setActiveFaq] = useState(null);

  const faqs = [
    {
      q: "Kann ich den Thermomix® in Krefeld testen, bevor ich ihn kaufe?",
      a: "Absolut! Bei mir in Krefeld und Umgebung ist das Testen sogar ausdrücklich erwünscht. Bei einem unverbindlichen Erlebniskochen zeige ich dir das Gerät live in Aktion. Du kochst selbst und kannst alle Funktionen ausgiebig prüfen."
    },
    {
      q: "Was muss ich für die Vorführung vorbereiten?",
      a: "Fast nichts! Ich bringe das Gerät und einen Großteil der Zutaten mit. Du bekommst von mir vorab eine kurze Einkaufsliste – meist sind das nur frische Sachen, die in den Kühlschrank müssen (z.B. Fleisch, Sahne) und ein paar Standard-Gewürze, die du wahrscheinlich eh zuhause hast. Du brauchst nur eine Steckdose und ein bisschen Zeit – wir kochen gemeinsam und du kannst direkt probieren."
    },
    {
      q: "Wie läuft eine Vorführung bei dir ab?",
      a: 'Eine klassische Vorführung dauert etwa 2 Stunden und besteht aus 5 Gängen, die wir gemeinsam zubereiten: Eis, Brot/Brötchen, Salat, Dip und eine Hauptspeise. Als Gastgeber*in lädst du idealerweise 3 weitere Haushalte ohne TM7 ein – mehr Gäste sind natürlich willkommen. 3 Gäste sind das Minimum, damit es ein echtes „Erlebniskochen" wird.'
    },
    {
      q: "Was ist das Wunschrezept – und wann macht das Sinn?",
      a: "Wenn du dich nicht für die klassische Vorführung mit Gästen entscheidest, kannst du dir auch einfach ein Wunschgericht aussuchen und wir kochen es zu zweit zusammen – ganz entspannt, ohne weitere Gäste. So kannst du den TM7 in Ruhe an einem Gericht testen, das dir wirklich wichtig ist."
    },
    {
      q: "Gibt es beim Kauf über dich eine Finanzierung?",
      a: "Ja, Vorwerk bietet über Partnerbanken attraktive Finanzierungsmodelle an. Oft gibt es Sonderaktionen mit 0% Zinsen über 12 oder 24 Monate. Aktuell kannst du den TM7 schon ab ca. 50 € monatlich finanzieren. Ich berate dich gerne zu den aktuellen Optionen."
    },
    {
      q: "Wie lange ist die Lieferzeit in Krefeld?",
      a: "Die Lieferzeiten variieren je nach Auftragslage bei Vorwerk. Meist liegt sie zwischen 2 und 4 Wochen. Da ich als Repräsentantin direkten Einblick in das System habe, nenne ich dir den tagesaktuellen Status."
    },
    {
      q: "Was unterscheidet deinen Service vom Online-Kauf?",
      a: "Beim Online-Kauf bist du auf dich allein gestellt. Bei mir erhältst du das Rundum-Sorglos-Paket: Einweisung vor Ort, persönliche Ansprechpartnerin und Hilfe bei Servicefällen. In meiner exklusiven Kunden-WhatsApp-Gruppe für den Raum Krefeld tauschen wir uns aus."
    }
  ];

  return (
    <section id="faq" data-testid="faq-section" className="section-padding bg-white" ref={sectionRef}>
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16 reveal">
          <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
            <HelpCircle className="w-8 h-8 text-emerald-600" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4 font-[Outfit]">
            Häufige Fragen zum Thermomix® in Krefeld
          </h2>
          <p className="text-slate-600 text-lg">
            Alles Wichtige zur Vorführung und Beratung.
          </p>
        </div>

        <div className="space-y-4 reveal reveal-delay-1">
          {faqs.map((faq, i) => (
            <div key={i} className="glass-card rounded-2xl overflow-hidden">
              <button
                onClick={() => setActiveFaq(activeFaq === i ? null : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-white/50 transition"
              >
                <span className="font-semibold text-slate-800 pr-4">{faq.q}</span>
                {activeFaq === i 
                  ? <Minus className="w-5 h-5 text-emerald-600 flex-shrink-0" /> 
                  : <Plus className="w-5 h-5 text-slate-400 flex-shrink-0" />
                }
              </button>
              {activeFaq === i && (
                <div className="px-6 pb-5 text-slate-600 leading-relaxed animate-fade-in">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
